import { Incident } from '@silbo/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IncidentStepperLayout } from '../IncidentStepperLayout';
import { CommentStep } from '../steps/CommentStep';

type PatientMissingValue = Partial<Pick<Incident, 'comment'>>;

export function PatientMissing({
  onBack,
  onComplete,
}: {
  onBack: () => void;
  onComplete: (value: PatientMissingValue) => void;
}) {
  const { t } = useTranslation('patient-transport');

  const [value, setValue] = useState<PatientMissingValue>({});

  return (
    <IncidentStepperLayout
      title={t('fareIncidents.PATIENT_MISSING')}
      stepsLength={1}
      activeStep={0}
      isCurrentStepValid={true}
      onBack={onBack}
      onComplete={() => onComplete(value)}
    >
      <CommentStep value={value.comment} onChange={(comment) => setValue({ ...value, comment })} />
    </IncidentStepperLayout>
  );
}
